"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
/**
 * Рассчет КПП
 * @param employees Количество сотр.
 * @param avgPayment Средняя ЗП.
 * @param contribution Индексация заработной платы % (как десятичная дробь)
 */

function _default(employees, avgPayment, contribution, antikrizis, penetration) {
  if (!antikrizis && penetration) return employees * avgPayment * contribution * (penetration / 100);
  return employees * avgPayment * contribution;
}